import { gql } from '@apollo/client';
/**
 * Organizations the signed-in user belongs to, plus their role in the active one.
 *
 * Drives the organization switcher and decides whether the Organization Management entry is
 * shown. The backend re-checks the role on every call, so this is only for presentation.
 */
const GET_ORGANIZATIONS = gql `
  query GetOrganizations {
    me {
      id
      organizationRole
      currentTenant {
        id
        name
        status
      }
      tenants {
        edges {
          node {
            id
            name
            provisioningStatus
          }
        }
      }
    }
  }
`;
export default GET_ORGANIZATIONS;
